import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {MetadataPanelComponent} from '../../shared/vte';
import {VisionProviderDiagnostics, VisionProviderSummary} from '../../models/vision-provider-management';
import {VisionProviderManagementViewService} from '../../services/vision-provider-management';
import {MetadataEntry} from '../../services/vte/vehicle-transaction-view.service';

@Component({
    selector: 'app-provider-overview',
    standalone: true,
    imports: [CommonModule, RouterLink, MetadataPanelComponent],
    templateUrl: './provider-overview.component.html',
    styleUrl: './provider-overview.component.css',
})
export class ProviderOverviewComponent implements OnInit {
    providerId = '';
    summary: VisionProviderSummary | null = null;
    overviewEntries: MetadataEntry[] = [];
    loading = false;

    constructor(
        private route: ActivatedRoute,
        private viewService: VisionProviderManagementViewService,
    ) {
    }

    ngOnInit(): void {
        this.route.parent?.paramMap.subscribe((params) => {
            this.providerId = params.get('providerId') || '';
            this.loadOverview();
        });
    }

    loadOverview(): void {
        if (!this.providerId) {
            return;
        }
        this.loading = true;
        this.viewService.loadProviderSummary(this.providerId).subscribe({
            next: (summary) => {
                this.summary = summary;
                this.overviewEntries = this.buildOverviewEntries(summary.diagnostics);
                this.loading = false;
            },
            error: () => {
                this.summary = null;
                this.overviewEntries = [];
                this.loading = false;
            },
        });
    }

    private buildOverviewEntries(diagnostics: VisionProviderDiagnostics): MetadataEntry[] {
        return [
            {key: 'provider', label: 'Provider', value: diagnostics.provider_label},
            {key: 'provider_id', label: 'Provider ID', value: diagnostics.provider_id},
            {key: 'health', label: 'Health', value: this.viewService.buildProviderSummary(diagnostics).health_label},
            {
                key: 'active_subscriptions',
                label: 'Active Subscriptions',
                value: String(diagnostics.active_local_subscription_count),
            },
            {
                key: 'last_sync',
                label: 'Last Synchronization',
                value: this.viewService.formatTimestamp(
                    this.viewService.getLastSynchronizedAt(diagnostics.provider_id),
                ),
            },
            {key: 'default_webhook_url', label: 'Default Webhook URL', value: diagnostics.default_webhook_url || '—'},
        ];
    }
}
